import { Car, ShieldCheck, HardHat, ScanLine, Compass, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

const SERVICES = [
  {
    icon: Car,
    title: "Mobile Patrol",
    desc: "Marked patrol units delivering randomized, high-visibility deterrence across your properties around the clock.",
    span: "md:col-span-7",
    testid: "service-mobile-patrol",
  },
  {
    icon: ShieldCheck,
    title: "Static Guarding",
    desc: "Trained, uniformed guards providing a steady, protective on-site presence.",
    span: "md:col-span-5",
    testid: "service-static-guarding",
  },
  {
    icon: ScanLine,
    title: "Access Control",
    desc: "Controlled entry, credential verification and visitor management for secured facilities.",
    span: "md:col-span-5",
    testid: "service-access-control",
  },
  {
    icon: HardHat,
    title: "Industrial & Construction Site Security",
    desc: "Asset, equipment and materials protection for active and dormant industrial and build sites.",
    span: "md:col-span-7",
    testid: "service-industrial-construction",
  },
  {
    icon: Compass,
    title: "Risk Management & Consulting",
    desc: "Threat assessments, security audits and tailored strategy from experienced professionals who understand your risk.",
    span: "md:col-span-12",
    testid: "service-risk-consulting",
  },
];

export const Services = () => {
  const scrollTo = (s) => document.querySelector(s)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="services" data-testid="services-section" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal className="max-w-3xl">
          <span className="text-xs font-bold uppercase tracking-[0.24em] text-[color:var(--primary-text)]">
            What We Protect
          </span>
          <h2 className="mt-5 font-display text-4xl md:text-6xl tracking-tight leading-none">
            A full spectrum of{" "}
            <span className="font-editorial italic">security services</span>.
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-6">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.title} delay={i * 0.06} className={s.span}>
                <div
                  data-testid={s.testid}
                  className="group h-full bg-[color:var(--surface)] border border-white/10 rounded-sm p-7 md:p-8 transition-colors duration-300 hover:border-[color:var(--primary)]/40 hover:-translate-y-1 transition-transform relative overflow-hidden"
                >
                  <div className="absolute -right-16 -top-16 h-48 w-48 rounded-full bg-[color:var(--primary)]/0 group-hover:bg-[color:var(--primary)]/10 blur-3xl transition-colors duration-500" />
                  <div className="relative flex items-start justify-between">
                    <span className="inline-flex h-12 w-12 items-center justify-center rounded-sm border border-white/10 bg-black text-[color:var(--primary-text)]">
                      <Icon size={22} />
                    </span>
                    <ArrowUpRight
                      size={20}
                      className="text-secondary opacity-0 group-hover:opacity-100 group-hover:text-white transition-all"
                    />
                  </div>
                  <h3 className="relative mt-6 font-display text-xl md:text-2xl tracking-tight">
                    {s.title}
                  </h3>
                  <p className="relative mt-3 text-secondary leading-relaxed max-w-xl">
                    {s.desc}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.1} className="mt-12">
          <button
            onClick={() => scrollTo("#contact")}
            data-testid="services-cta-button"
            className="inline-flex items-center gap-2 bg-[color:var(--primary)] hover:bg-[color:var(--primary-hover)] text-white font-semibold px-7 py-4 rounded-sm transition-colors"
          >
            Discuss your requirements <ArrowUpRight size={18} />
          </button>
        </Reveal>
      </div>
    </section>
  );
};
